module.exports = __webpack_public_path__ + "static/img/zoomExtends.5f78e86f.png";